/**
 * Scroll al formulario de registro de agentes (#form-section).
 * En landings el contenedor de scroll es document.body (no window).
 */
export function scrollToProvidersForm(opts = {}) {
  const el = document.getElementById('form-section')
  if (!el) return false
  const offset = opts.offset != null ? opts.offset : 110
  const scroller = document.body
  const top = el.getBoundingClientRect().top + scroller.scrollTop - offset
  scroller.scrollTo({
    top: Math.max(0, top),
    behavior: opts.instant ? 'auto' : 'smooth'
  })
  return true
}

/** Reintenta hasta que el target exista y la posición se estabilice (imágenes/hero). */
export function scrollToProvidersFormReliable() {
  let tries = 0
  const run = () => {
    tries += 1
    const ok = scrollToProvidersForm({ instant: tries === 1 })
    if (!ok && tries < 25) {
      setTimeout(run, 80)
      return
    }
    // Un ajuste extra cuando el layout termina de cargar
    if (ok && tries < 8) {
      setTimeout(() => scrollToProvidersForm({ instant: true }), 250)
    }
  }
  run()
}

export default {
  methods: {
    goToProvidersForm(e) {
      if (e && e.preventDefault) e.preventDefault()
      if (this.$route && this.$route.path === '/providers') {
        this.$nextTick(() => scrollToProvidersFormReliable())
        return
      }
      this.$router.push({ path: '/providers', hash: '#form-section' })
    }
  }
}
